document.querySelectorAll('[name="id"]').forEach(function(variantSelector) {
    variantSelector.addEventListener('change', function() {
     
      document.querySelectorAll('.variant-detail').forEach(detail => { 
        detail.style.display = 'none';
        detail.closest('.variant-detail-container').style.display = 'none';
      });
        
      var selectedVariantId = variantSelector.value;
      var selectedVariantDetail = document.querySelector('#variant-detail-' + selectedVariantId);
            
      if (selectedVariantDetail) { 
        selectedVariantDetail.style.display = 'none' 
        selectedVariantDetail.closest('.variant-detail-container').style.display = 'block';
      }
    });
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    
    var selectedVariantId = document.querySelector('[name="id"]').value;
    var selectedVariantDetail = document.querySelector('#variant-detail-' + selectedVariantId);
    
    
    if (selectedVariantDetail) {
      selectedVariantDetail.style.display = 'block';
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const variantDetailContainers = document.querySelector('.Variant-Main-Container');
    const variantDetailContainersArray = variantDetailContainers.querySelectorAll('.variant-detail-container');
  
    let varIdFromUrl = window.location.href;
    
    
    if (varIdFromUrl.includes('variant=')) {
      let queryString = window.location.search;
      let params = new URLSearchParams(queryString);
  
      
      let variantId = params.get('variant');
      
      console.log('Variant ID from URL:', variantId);
  
     
      variantDetailContainersArray.forEach(variantDetailContainer => {
        if (variantDetailContainer.dataset.parent === variantId) {
          variantDetailContainer.style.display = 'block';
          variantDetailContainer.querySelector('.variant-detail').style.display = 'none';
        } 
        else { variantDetailContainer.style.display = 'none'; }
      });
  
      console.log('Variant details updated');
      
    } 
    else { variantDetailContainersArray[0].style.display = 'block'; variantDetailContainersArray[0].querySelector('.variant-detail').style.display = 'none'; }
  });
  

window.toggleVariantDetails = function(variantId) {
  var detailDiv = document.getElementById("variant-detail-" + variantId);
  var toggleButton = document.getElementById("toggle-" + variantId);

  if (detailDiv.style.display === "none") {
    detailDiv.style.display = "block";
    toggleButton.innerHTML = "-";
  } else {
    detailDiv.style.display = "none";
    toggleButton.innerHTML = "+";
  }
}